import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../../../classes/dto-selected-merchant-or-product";
import {
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_CART,
} from "../../../../database/store-data";
import {
  ENTRY_MODE,
  STORE_SHEDULEDateNTime,
  STORE_DineType,
} from "../../../../database/store-names";
import { useState, useCallback, useEffect } from "react";
import { dto_cart_checkout } from "../../../../classes/dto-cart-checkout";
import { ENCRYPT_STORAGE } from "../../../../config/config";
import { GET_CART_COUNT } from "../../../../functions/funtion";
import {
  GET_CART,
  GET_CART_SELECT_MERCHATS_ZONE,
} from "../../../../database/get-stored-data";
import { Colors } from "../../../../util/colors";
import Alert from "../../../../components/Alert";

const QtyPlusViewOnProductListView = ({
  item,
  onCartUpdated,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMinus, setShowMinus] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const activeMerchantMid =
    Number(dto_selected_merchant_or_product.MID) ||
    Number(dto_selected_final_merchant_or_product.MID) ||
    Number(item.MID) ||
    0;

  const isMatchingCartItem = useCallback(
    (cartItem) => {
      if (!cartItem) {
        return false;
      }

      const cartBasePid = Number(cartItem.BasePID || 0);
      const itemBasePid = Number(item.PI || item.PID || 0);
      const cartPid = Number(cartItem.PID || cartItem.PI || 0);
      const itemPid = Number(item.PI || item.PID || 0);

      return (
        (cartBasePid !== 0 && itemBasePid !== 0 && cartBasePid === itemBasePid) ||
        (cartBasePid === 0 &&
          itemBasePid !== 0 &&
          cartPid !== 0 &&
          cartPid === itemPid)
      );
    },
    [item],
  );

  const updateBasketCount = useCallback((cartItems) => {
    const lbl = document.getElementById("viewBasketCount");
    if (!lbl) {
      return;
    }

    const count = Array.isArray(cartItems) ? cartItems.length : 0;
    lbl.textContent = String(count);
    lbl.style.display = count > 0 ? "block" : "none";
  }, []);

  const syncQuantityFromCart = useCallback(
    (cartItems, merchantMid = activeMerchantMid) => {
      const normalizedCart = Array.isArray(cartItems) ? cartItems : [];
      const cartMerchantMid =
        Number(normalizedCart?.[0]?.MID) || Number(merchantMid) || 0;

      if (cartMerchantMid !== 0 && activeMerchantMid !== cartMerchantMid) {
        setQuantity(0);
        setShowMinus(false);
        setIsExpanded(false);
        return;
      }

      const matchedProducts = normalizedCart.filter(isMatchingCartItem);

      if (matchedProducts.length > 0) {
        const totalQuantity = matchedProducts.reduce(
          (sum, cartItem) => sum + (Number(cartItem.Qty) || 0),
          0,
        );
        setQuantity(totalQuantity);
        setShowMinus(totalQuantity > 0);
        return;
      }

      setQuantity(0);
      setShowMinus(false);
      setIsExpanded(false);
    },
    [activeMerchantMid, isMatchingCartItem],
  );

  const CartAddNewItemList = useCallback(
    async (CartList, ProductInfo, i) => {
      if (i === 0 && CartList === undefined) {
        CartList = [];
        CartList.push(ProductInfo);
        await SET_STORE_CART_SELECT_MERCHATS_ZONE(
          dto_selected_merchant_or_product,
        );
      } else if (i === -1) {
        CartList.push(ProductInfo);
      } else {
        CartList[i] = ProductInfo;
      }

      dto_selected_final_merchant_or_product.MID = activeMerchantMid;
      await SET_STORE_CART(CartList);
    },
    [activeMerchantMid],
  );

  const CartChangeMerchant = useCallback(
    async (CartList, ProductInfo, i) => {
      CartList = [];
      ENCRYPT_STORAGE.removeMultipleItems([
        "STORE_Cart",
        "STORE_Addons",
        "STORE_FinaleSelelctCartMerchantNZone",
      ]);
      await CartAddNewItemList(CartList, ProductInfo, i);
    },
    [CartAddNewItemList],
  );

  const dispatchCartUpdated = useCallback(
    (cartItems, merchantMid) => {
      window.dispatchEvent(
        new CustomEvent("cartUpdated", {
          detail: {
            cart: cartItems,
            merchantMid,
          },
        }),
      );
    },
    [],
  );

  const addToCart = useCallback(
    async (currentQuantity) => {
      let LocalCart = await GET_CART();
      const cartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
      const cartMerchantMid =
        Number(LocalCart?.[0]?.MID) || Number(cartMerchant?.MID) || 0;
      const productMerchantMid = activeMerchantMid;

      const ProductInfo = {
        LineID: LocalCart !== undefined ? LocalCart.length + 1 : 1,
        PID: item.PI,
        BasePID: item.PI,
        TID: item.TI,
        Code: item.C,
        ProductImageUrl: item.IU,
        Desc: item.D,
        USeqID: item.UI,
        UOM: item.U,
        UP: item.P,
        UD: item.UD,
        Qty: currentQuantity,
        DecPoint: item.DecPoint || item.DP || "n0",
        Total: 0,
        Modification: "",
        ExtraCost: 0,
        DocDiscount: 0,
        VAT: 0,
        TAXID: item.Y,
        TaxEquation: item.TE || "SUM * 0/100",
        MID: activeMerchantMid,
        GDescription: item.G,
        IsAvailable: item.A,
        ADDONLINEID: 0,
        UDPer: 0,
        IsRecommended: 0,
      };
      if (LocalCart === undefined) {
        await CartAddNewItemList(LocalCart, ProductInfo, 0);
        LocalCart = [ProductInfo];
      } else if (
        cartMerchantMid === 0 ||
        productMerchantMid === cartMerchantMid
      ) {
        const existingProductIndex = LocalCart.findIndex(isMatchingCartItem);

        if (existingProductIndex !== -1) {
          LocalCart[existingProductIndex].Qty = currentQuantity;
        } else {
          LocalCart.push(ProductInfo);
        }
        await SET_STORE_CART(LocalCart);
      } else {
        Alert.ConfirmationMessageBox({
          Tittle: "Change Merchant",
          Text: "Selecting a different Merchant will clear your current cart. Do you wish to continue?",
          Icon: "warning",
          ConfirmButtonText: "Yes",
          ConfirmButtonFunction: async () => {
            await CartChangeMerchant(LocalCart, ProductInfo, -1);
            await SET_STORE_CART_SELECT_MERCHATS_ZONE(
              dto_selected_merchant_or_product,
            );
            ENCRYPT_STORAGE.removeMultipleItems([
              STORE_SHEDULEDateNTime,
              STORE_DineType,
            ]);
            dto_cart_checkout.PromoHeader = "";
            dto_cart_checkout.PromoGuid = 0;
            dto_cart_checkout.PromoCODE = "";
            dto_cart_checkout.DiscountPersentage = 0;
            dto_cart_checkout.DiscountTotal = 0;
            dto_cart_checkout.Comment = "";
          },
          DismissButtonFunction: () => {},
        });
        return;
      }
      const updatedCart = Array.isArray(LocalCart) ? [...LocalCart] : [];
      updateBasketCount(updatedCart);
      if (typeof onCartUpdated === "function") {
        onCartUpdated(updatedCart);
      }
      dispatchCartUpdated(updatedCart, productMerchantMid);
      await GET_CART_COUNT(updatedCart);
    },
    [
      item,
      CartAddNewItemList,
      CartChangeMerchant,
      activeMerchantMid,
      dispatchCartUpdated,
      isMatchingCartItem,
      onCartUpdated,
      updateBasketCount,
    ],
  );

  const deleteFromCart = useCallback(async () => {
    let LocalCart = await GET_CART();
    if (!LocalCart || LocalCart.length === 0) {
      return;
    }
    const productIndex = LocalCart.findIndex(isMatchingCartItem);

    if (productIndex !== -1) {
      const removeItem = async () => {
        LocalCart.splice(productIndex, 1);

        LocalCart = LocalCart.map((item, index) => ({
          ...item,
          LineID: index + 1,
        }));

        await SET_STORE_CART(LocalCart);
        updateBasketCount(LocalCart);
        await GET_CART_COUNT(LocalCart);
        const updatedCart = [...LocalCart];
        if (typeof onCartUpdated === "function") {
          onCartUpdated(updatedCart);
        }
        dispatchCartUpdated(updatedCart, activeMerchantMid);
        setQuantity(0);
        setShowMinus(false);
      };

      if (ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR") {
        await removeItem();
        return;
      }

      Alert.ConfirmationMessageBox({
        ConfirmButtonFunction: removeItem,
        ConfirmButtonText: "Yes",
        DismissButtonFunction: () => {},
        Icon: "info",
        Text: "Are you sure you want to remove this item from your cart?",
        Tittle: "Remove From Cart",
      });
    }
  }, [
    activeMerchantMid,
    dispatchCartUpdated,
    isMatchingCartItem,
    onCartUpdated,
    updateBasketCount,
  ]);

  const checkCartForProduct = useCallback(async () => {
    const LocalCart = await GET_CART();
    const cartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
    syncQuantityFromCart(LocalCart, cartMerchant?.MID);
  }, [syncQuantityFromCart]);

  useEffect(() => {
    checkCartForProduct();
  }, [checkCartForProduct]);

  useEffect(() => {
    const handleCartUpdated = (event) => {
      const updatedCart = event?.detail?.cart;
      if (Array.isArray(updatedCart)) {
        syncQuantityFromCart(updatedCart, event?.detail?.merchantMid);
        return;
      }

      checkCartForProduct();
    };

    window.addEventListener("cartUpdated", handleCartUpdated);
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdated);
    };
  }, [checkCartForProduct, syncQuantityFromCart]);

  const toggleExpand = useCallback(
    (event) => {
      event.stopPropagation();
      setIsExpanded((prevExpanded) => !prevExpanded);
    },
    [],
  );

  const incrementQuantity = useCallback(
    (event) => {
      event.stopPropagation();
      setQuantity((prevQuantity) => {
        let newQuantity = prevQuantity + 1;
        if (item.Q > 0 && newQuantity > item.Q) {
          Alert.ConfirmationMessageBox({
            Tittle: "Maximum Quantity Reached",
            Text: `Sorry, you cannot add more than ${item.Q} of ${item.D}.`,
            Icon: "warning",
            ConfirmButtonText: "OK",
            DismissButtonFunction: () => {},
          });
          return prevQuantity;
        }
        setShowMinus(true);
        if (prevQuantity === 0) {
          setIsExpanded(true);
        }
        addToCart(newQuantity);
        return newQuantity;
      });
    },
    [addToCart, item.D, item.Q],
  );

  const decrementQuantity = useCallback(
    (event) => {
      event.stopPropagation();
      if (quantity <= 1) {
        deleteFromCart();
        return;
      }

      setQuantity((prevQuantity) => {
        const newQuantity = prevQuantity - 1;
        setShowMinus(newQuantity > 0);
        addToCart(newQuantity);
        return newQuantity;
      });
    },
    [addToCart, deleteFromCart, quantity],
  );

  const handleOnClick = useCallback(
    (event) => {
      if (!isExpanded && quantity === 0) {
        incrementQuantity(event);
      } else {
        toggleExpand(event);
      }
    },
    [isExpanded, quantity, incrementQuantity, toggleExpand],
  );

  return (
    <div
      id="qty"
      onClick={handleOnClick}
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        fontSize: "20px",
        color: isExpanded || quantity > 0 ? "white" : "black",
        backgroundColor:
          isExpanded || quantity > 0 ? Colors.DarkGreyScale : "white",
        border: "0.25px solid black",
        padding: "3px",
        borderRadius: "200px",
        cursor: "pointer",
        width: isExpanded ? "95px" : "37px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "0px",
      }}
    >
      {isExpanded ? (
        <>
          {quantity > 0 && (
            <>
              {showMinus ? (
                <div
                  onClick={decrementQuantity}
                  style={{
                    marginRight: "19px",
                    fontSize: "22px",
                    fontWeight: "bolder",
                  }}
                >
                  {" "}
                  -{" "}
                </div>
              ) : (
                <i
                  className="bi bi-trash"
                  onClick={deleteFromCart}
                  style={{ marginRight: "19px", fontSize: "17px" }}
                />
              )}
              <span
                style={{
                  fontSize: "14px",
                  marginRight: "19px",
                  fontWeight: "bolderer",
                }}
              >
                {quantity}
              </span>
            </>
          )}
          <div
            onClick={incrementQuantity}
            style={{ fontSize: "22px", fontWeight: "bolder" }}
          >
            +
          </div>
        </>
      ) : quantity > 0 ? (
        <span style={{ fontSize: "18px", fontWeight: "bolderer" }}>
          {quantity}
        </span>
      ) : (
        <div style={{ fontSize: "25px", fontWeight: "bolder" }}> + </div>
      )}
    </div>
  );
};

export default QtyPlusViewOnProductListView;
